import React, { memo } from 'react';

function MainMenu({ user, onStartClassic, onStartDaily, onShowLeaderboard, onShowProfile, onSignOut, onShowSubscription, isPremium }) {
  const isGuest = !user;

  return (
    <div className="main-menu">
      <div className="menu-header">
        <h1 className="menu-title">BLOCK BLAST</h1>
        <p className="menu-subtitle">
          {isGuest ? 'Playing as Guest' : `Welcome, ${user.displayName || user.username || 'Player'}`}
        </p>
      </div>

      <div className="menu-actions">
        <button className="menu-btn menu-btn-play" onClick={onStartClassic}>
          <span className="menu-btn-icon">&#9654;</span>
          <span className="menu-btn-text">
            <span className="menu-btn-label">CLASSIC MODE</span>
            <span className="menu-btn-desc">Chase your high score</span>
          </span>
        </button>

        <button className="menu-btn menu-btn-daily" onClick={onStartDaily} disabled={isGuest}>
          <span className="menu-btn-icon">&#9733;</span>
          <span className="menu-btn-text">
            <span className="menu-btn-label">DAILY CHALLENGE</span>
            <span className="menu-btn-desc">{isGuest ? 'Sign in to compete' : 'Same puzzle for everyone'}</span>
          </span>
        </button>

        <button className="menu-btn menu-btn-leaderboard" onClick={onShowLeaderboard} disabled={isGuest}>
          <span className="menu-btn-icon">&#9776;</span>
          <span className="menu-btn-text">
            <span className="menu-btn-label">LEADERBOARD</span>
            <span className="menu-btn-desc">{isGuest ? 'Sign in to view' : 'Top players worldwide'}</span>
          </span>
        </button>

        {!isGuest && (
          <button className="menu-btn menu-btn-profile" onClick={onShowProfile}>
            <span className="menu-btn-icon">&#9679;</span>
            <span className="menu-btn-text">
              <span className="menu-btn-label">PROFILE</span>
              <span className="menu-btn-desc">Stats & settings</span>
            </span>
          </button>
        )}
      </div>

      {!isPremium && onShowSubscription && (
        <button className="menu-btn-premium" onClick={onShowSubscription}>
          <span className="menu-btn-premium-icon">&#9733;</span>
          <span className="menu-btn-premium-text">Unlock all themes, no ads & more</span>
        </button>
      )}

      <div className="menu-footer">
        {!isGuest && (
          <button className="menu-link" onClick={onSignOut}>Sign Out</button>
        )}
      </div>
    </div>
  );
}

export default memo(MainMenu);
